import { StylesConfig } from 'react-select';
import { IMultiSelectOptionInternal } from '@components-shared/forms/MultiSelect/interfaces';

const validationErrorColor = '#ef4836';

export const getCustomStyles = ({ valid }: { valid: boolean }): StylesConfig<IMultiSelectOptionInternal, true> => ({
  control: (base) => ({
    ...base,
    '&:hover': { borderColor: 'none' },
    'cursor': 'pointer',
    'border': valid ? base.border : `1px solid ${validationErrorColor}`,
    'boxShadow': valid ? base.boxShadow : `0 0 0 1px ${validationErrorColor}`,
  }),
});
